const STORAGE_KEY = 'bhima-store.pos-sale';

/**
 * In-progress POS sale for this browser tab. Survives route changes
 * (Inventory, Products, Bulk onboarding) and is dropped when the tab closes.
 */
export function loadPosSaleCache(sub) {
  if (!sub) return null;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed?.sub !== sub || !parsed.sale || typeof parsed.sale !== 'object') return null;
    return parsed.sale;
  } catch {
    return null;
  }
}

export function savePosSaleCache(sub, sale) {
  if (!sub || !sale) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ sub, sale }));
  } catch {
    // Private mode / quota — the open screen still keeps the cart.
  }
}

export function clearPosSaleCache() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Nothing to clear.
  }
}
